// extracted by mini-css-extract-plugin
export default {"fill":"Fill_fill__ZeWeI"};